import dayjs from 'dayjs'; // Dentro del componente `Datatable`
const formatDate = (date) =>
  date ? dayjs(date).format('YYYY-MM-DD') : "";

const formatHour = (hour) =>
  hour ? dayjs(hour).format('HH:mm') : "";


export const formatRows = (listaItems) => {
  const formatDistancia = (metros) => {
    if (metros == null || isNaN(metros)) return null;

    return metros < 1000
      ? `${Math.round(metros)} m`
      : `${(metros / 1000).toFixed(2)} km`;
  };
  return listaItems.map((item) => ({
    id: item.vis_id ?? "Id no disponible",
    razon_social: item.cliente?.razon_social ?? "Cliente no disponible",
    cli_name: item.cliente?.cli_name ?? "",
    codigo_cliente: item.cli_codigo ?? "Código no disponible",
    cli_latitud: item.cli_latitud ?? "No registrada",
    cli_longitud: item.cli_longitud ?? "No registrada",
   direccion: 
  item?.cliente?.cli_direccion && item?.cliente?.cli_nro_calle
    ? `${item.cliente.cli_direccion} ${item.cliente.cli_nro_calle}`
    : "Dirección no disponible",
     vendedor_id: item.sel_id ?? "Vendedor no disponible",
    fecha: item.vis_fecha ?? "Fecha no disponible",
    hora: item.vis_hora ?? "Hora no disponible",
    observacion: item.vis_observacion ?? "Sin observación",
    latitud: item.vis_latitud ?? "No registrada",
    longitud: item.vis_longitud ?? "No registrada",
    estado_pedido: item.cli_estado_pedido === 0 ? "✅SI " : "⛔NO",
    distancia_metros: formatDistancia(item.distancia_metros),
    sel_name: item.sel_name ?? "Preventista no disponible",
  }));
};

export const formatRowsImpresion = (listaItems) => {
  const formatDistancia = (metros) => {
    if (metros == null || isNaN(metros)) return null;

    return metros < 1000
      ? `${Math.round(metros)} m`
      : `${(metros / 1000).toFixed(2)} km`;
  };

  return listaItems.map((item) => { 
    const fecha = (() => {
      if (!item.vis_fecha || !item.vis_hora) return "Fecha no disponible";
      const dt = dayjs(`${item.vis_fecha}T${item.vis_hora}`);
      return dt.isValid() ? dt.format("DD-MM-YY HH:mm") : "Fecha no disponible";
    })();


    return {
      razon_social: item.cliente?.razon_social ?? "Cliente no disponible",
      cli_name: item.cliente?.cli_name ?? "",
      codigo_cliente: item.cli_codigo ?? "Código no disponible",
      direccion: item?.cliente?.cli_direccion ?? "Dirección no disponible",
      fecha: fecha,
      estado_pedido: item.cli_estado_pedido === 0 ? "SI" : "NO",
      distancia_metros: formatDistancia(item.distancia_metros),
      sel_name: item.sel_name ?? "Preventista no disponible",
    };
  });
};
